/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Class_TableInputs */

const en_reading_class_table = /** @type {(inputs: Reading_Class_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tables`)
};

const es_reading_class_table = /** @type {(inputs: Reading_Class_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tablas`)
};

/**
* | output |
* | --- |
* | "Tables" |
*
* @param {Reading_Class_TableInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reading_class_table = /** @type {((inputs?: Reading_Class_TableInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Class_TableInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reading_class_table(inputs)
	return en_reading_class_table(inputs)
});